var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZilapp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 62,
    viewBox: "0 0 177 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.158 8.58716C166.253 8.58716 176.344 18.3943 176.345 30.6584C176.345 42.8489 166.479 52.7321 154.31 52.7327C150.816 52.7326 147.513 51.9139 144.578 50.4641V61.4709H132.274V31.5393C132.274 19.4161 141.914 8.58856 154.158 8.58716ZM154.158 20.9104C148.86 20.9114 144.577 25.1999 144.576 30.6584C144.576 36.0429 148.934 40.4084 154.31 40.4084C159.684 40.4078 164.04 36.0425 164.04 30.6584C164.039 25.3491 159.607 20.9104 154.158 20.9104Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0303 52.8838H48.6904V20.1562H61.0303V52.8838Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7217 52.8838H67.501V0H80.7217V52.8838Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2812 8.74316V30.8896H97.2676C97.3192 43.3893 115.677 43.3896 115.729 30.8896H115.715V8.74316H128.033L128.032 31.3237C128.032 31.4745 128.029 31.1737 128.025 31.3237C128.028 31.4522 128.032 31.195 128.032 31.3237H128.012C127.161 60.0244 86.3929 60.0452 84.9629 31.3237V8.74316H97.2812Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1475 7.5752C47.1478 -2.21639 62.5719 -2.21639 62.5723 7.5752C62.5723 17.3672 47.1475 17.3672 47.1475 7.5752Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7988 40.7432L35.8623 40.6143C39.1784 40.6145 41.8662 43.3323 41.8662 46.6846C41.866 50.0366 39.1782 52.7537 35.8623 52.7539L0 52.8838L23.2705 12.1396L8.20801 12.2822C4.8918 12.2822 2.20312 9.56423 2.20312 6.21191C2.20331 2.85976 4.89191 0.142643 8.20801 0.142578L44.0703 0L20.7988 40.7432Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZilapp);
export default __webpack_public_path__ + "static/media/zilapp.355f58a09d8093125f076b55fdd2c0e7.svg";
export { ForwardRef as ReactComponent };